"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackEecAddToCart = void 0;
const pushToDataLayer_1 = require("./pushToDataLayer");
const buildEecProduct_1 = require("./buildEecProduct");
const enums_1 = require("../enums");
const buildGA4ProductDetail_1 = require("./buildGA4ProductDetail");
const clearGA4EventData_1 = require("./clearGA4EventData");
function trackEecAddToCart({ product, quantity, variant, itemListName, cart_item_count, }) {
    (0, clearGA4EventData_1.clearGA4EventData)();
    const eecProduct = (0, buildEecProduct_1.buildEecProduct)({ product, quantity, variant });
    const eventData = (0, buildGA4ProductDetail_1.buildGA4ProductDetailInteraction)({
        eventName: enums_1.GA4EventName.AddToCart,
        featureCategory: enums_1.GA4FeatureCategory.Ecommerce,
        bookingType: enums_1.BookingType.DirectBooking,
        product,
        variant,
        quantity,
        itemListName,
    });
    const eecData = {
        event: enums_1.EventName.EECAddToCart,
        cart_item_count,
        ecommerce: {
            add: {
                products: [eecProduct],
            },
        },
        ...eventData,
    };
    (0, pushToDataLayer_1.pushToDataLayer)(eecData);
}
exports.trackEecAddToCart = trackEecAddToCart;
//# sourceMappingURL=trackEecAddToCart.js.map